import { MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBRow } from 'mdbreact';
import React from 'react';
import { Link as RouterLink, Redirect } from 'react-router-dom';
import vi_logo from '../../Assets/visaero_logo.png';
import vd_logo from '../../Assets/visadone_logo.png';
import styles from './Login.module.css';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import axios from '../../authAxios'
// import { Input } from '@material-ui/core';
// import axios from 'axios'
import TextField from '@material-ui/core/TextField';
import { emailValidation } from '../Common/Utility/validation';

const brand_color = localStorage.getItem("brand_color")
export class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            country_code: '91',
            ccode: [],
            isRegisteredUser: false,
            isNewUser: false,
            email: '',
            isError: false,
            email_err_txt: '',
            logo: '',
            host_name: 'VisaDone',
            brand_color: "",
            country_cioc: ''
        }
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    componentDidMount() {
            const host = localStorage.getItem('host');
            const brand = localStorage.getItem('brand');
            const brand_color = localStorage.getItem('brand_color');
            localStorage.clear()
            localStorage.setItem("host",host)
            localStorage.setItem("brand",brand)
            localStorage.setItem("brand_color",brand_color)

            this.setState({ brand_color: localStorage.getItem("brand_color") })
            
            //localStorage.setItem('session_id',"")
            if (host === "visaero") {
                this.setState({ logo: vi_logo })
                this.setState({ host_name: 'Visaero' })
            } else if (host === "visadone") {
                this.setState({ logo: vd_logo })
                this.setState({ host_name: 'VisaDone' })
            }
            
        
    }
    handleOptionChange(event) {
        // console.log(event.target.value)
        var countryCodeObj = this.state.ccode.filter((c_code) => c_code.cioc === event.target.value)
        // console.log(countryCodeObj[0])

        this.setState({ country_code: countryCodeObj[0].callingCodes, country_cioc: countryCodeObj[0].cioc })
    }

    handleEmail= (e) => {

        this.setState({
            email: e.target.value,
            isError: false,
            email_err_txt: ""
        })
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            // console.log('enter press here! ')
            this.handleVerifyOTPBtnClick(event)
        }
    }

    handleVerifyOTPBtnClick = e => {
        if (emailValidation(this.state.email) !== '') {
            //alert("valid mobile number")
            
                // console.log("Valid user")
                this.setState({
                    isError: true,
                    email_err_txt: emailValidation(this.state.email)
                })
            } else {
                this.setState({
                    isError: false,
                    email_err_txt: emailValidation(this.state.email)
                },() => this.api_checkUserExistance())
            
            // alert("Invalid mobile")
            

        }
    }

    api_getLoginOTP = e => {
        // console.log("GET OTP Clicked ....")
        if (emailValidation(this.state.email) !== "") {
            this.setState({ isValid: false })
            alert("Invalid mobile")
        } else {
            this.setState({ isValid: true })
            axios
                .post('/users/registerUserWithEmail', {
                    "email": this.state.email,

                    "host": window.location.hostname,
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then((resp) => {
                    this.setState({ user_id: resp.data.dataobj._id })
                    localStorage.setItem('user_id', resp.data.dataobj._id)
                    localStorage.setItem('email', this.state.email)
                    localStorage.setItem('country_code', "+" + this.state.country_code)

                    this.setState({ isOtpPresent: true })
                    this.setState({ getVerifyLink: '' })
                }).catch((err) => {
                    console.log(err);
                })
        }

    }

    api_checkUserExistance = e => {
        // console.log("Continue Clicked ....")
        if (emailValidation(this.state.email) !== '') {
            this.setState({ isValid: false })
        } else {
            this.setState({ isValid: true })
            axios
                .post('/users/checkUserExistanceWithEmail', {
                    "email": this.state.email,
                    "host": localStorage.getItem("host"),
                    "platform": "web"
                },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                .then((resp) => {
                    // console.log(resp)
                    if (resp.data.data === "error") {


                    } else {

                        localStorage.setItem('user_id', resp.data.user_id)
                        localStorage.setItem('email', this.state.email)
                        localStorage.setItem('country_code', "+" + this.state.country_code)
                        // console.log("user id")
                        // console.log(resp.data.user_id)
                        // console.log(localStorage.getItem("user_id"))
                        localStorage.setItem("coming_from", "")
                        if (resp.data.action === "enter_password") {
                            this.setState({ isRegisteredUser: true })
                        } else {
                            this.setState({ isNewUser: true })
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                })
        }


    }

    render() {
        if (this.state.isRegisteredUser) {
            return <Redirect to="/enter-password" />
        }
        if (this.state.isNewUser) {
            return <Redirect to="/verify-otp" />
        }
        return (


            <MDBCard size="sm" >
                <MDBCardBody >
                    <div className="text-center">
                        <img src={this.state.logo} className={localStorage.getItem("host") == "visadone" ? "visadone_logo" : "visaero_logo" + " img-fluid"}></img>
                    </div>
                    <div className="text-left mt-4">
                        <h3><b>Hello !</b></h3>
                    </div>
                    <div className="text-left">
                        <h5>Welcome to {this.state.host_name}</h5>
                    </div>
                    <MDBRow style={{ marginTop: '35.5%' }}>
                        {/* <MDBCol size="5" sm="5" md="5" lg="4">
                            <Select
                                style={{ top: '35.5%', width: '100%', textAlign: 'left' }}
                                name="country_code"
                                onChange={this.handleOptionChange}
                                value={this.state.country_cioc}
                            >
                                {
                                    this.state.ccode.map((flag) =>
                                        <MenuItem value={flag.cioc} key={flag.cioc}><img src={flag.flag} id={styles.flagThumbnail} />+{flag.callingCodes}</MenuItem>
                                    )
                                }
                            </Select>
                        </MDBCol> */}
                        <MDBCol size="12" sm="12" md="12" lg="12">
                            <div className="text-left" >
                                {/* <TextField
                                    style={{ width: '95%' }}
                                    error={this.state.isError}
                                    id="standard-error-helper-text"
                                    label="Mobile number"
                                    defaultValue=""
                                    value={this.state.email}
                                    onChange={this.handleMobileNumber}
                                    inputProps={{ maxLength: 20 }}
                                    helperText={this.state.email_err_txt}
                                    onKeyPress={this.handleKeyPress}
                                /> */}
                                <TextField
                                    style={{ width: '95%' }}
                                    error={this.state.isError}
                                    id="standard-error-helper-text"
                                    label="Email"
                                    defaultValue=""
                                    value={this.state.email}
                                    onChange={this.handleEmail}
                                    helperText={this.state.email_err_txt}
                                    onKeyPress={this.handleKeyPress}
                                />

                            </div>
                        </MDBCol>
                    </MDBRow>
                    <div style={{ margin: '8% 0' }}>

                        <MDBBtn id={styles.verifyBtn} style={{ backgroundColor: this.state.brand_color }} color={this.state.brand_color} onClick={this.handleVerifyOTPBtnClick}>Continue</MDBBtn>

                    </div>
                </MDBCardBody>
            </MDBCard>

        );
    }
};

export default Login;